import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const ordersRoutes: RouteObject[] = [
  {
    path: 'pedidos',
    element: <ModuleRoute module="checkout" permission="orders:read" />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./orders-list')).OrdersListPage }) },
      { path: ':id', lazy: async () => ({ Component: (await import('./order-detail')).OrderDetailPage }) },
    ],
  },
  {
    path: 'cobrar',
    element: <ModuleRoute module="checkout" permission="orders:write" />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('../sales/charge')).ChargePage }) },
      { path: ':orderId', lazy: async () => ({ Component: (await import('../sales/charge')).ChargeStatusPage }) },
    ],
  },
];
